import { useSelector } from 'react-redux';
import { selectVolumeCurveStreamRequestBySymbolStreamedData } from 'widgets/volumeCurve/store/data/streamSlice.ts';
import { usePortfolioSelection } from 'portfolio/store/hooks.ts';
import { useMemo } from 'react';
import { getStreamKey } from 'widgets/volumeCurve/store/data/request-utils.ts';
import { useVolumeCurveComponentSlice } from 'widgets/volumeCurve/store/component/componentSlice.ts';
import { useWidgetContext } from 'widgets/WidgetContext.tsx';
import cloneDeep from 'lodash/cloneDeep';

function useVolumeCurveWidgetStreamKey() {
    const { component } = useVolumeCurveComponentSlice();
    const { selectedOrder, selectedSymbol, symbology } =
        usePortfolioSelection();

    return useMemo(() => {
        if (!selectedOrder) {
            return undefined;
        }
        return getStreamKey(
            selectedSymbol!,
            symbology,
            selectedOrder,
            component
        );
    }, [component, selectedOrder, selectedSymbol, symbology]);
}

export function useVolumeCurveWidgetStreamedData() {
    const streamState = useSelector(
        selectVolumeCurveStreamRequestBySymbolStreamedData
    );
    const streamKey = useVolumeCurveWidgetStreamKey();
    const { widgetKey } = useWidgetContext();

    return useMemo(() => {
        const data = streamKey ? streamState[streamKey] : undefined;
        // eslint-disable-next-line no-console
        console.log('useVolumeCurveWidgetStreamedData returning', {
            streamKey,
            streamState: cloneDeep(streamState),
            data: cloneDeep(data),
            widgetKey,
        });
        return data;
    }, [streamState, streamKey, widgetKey]);
}
